import { scrollTo } from "../../assets/js/functions";

(function ($) {

    function matchHeightFire() {
      $(".posts_grid .post_card .post_card-title").matchHeight({
        property: "min-height",
      });

      $(".posts_grid .post_card .post_card-linkContainer").matchHeight({
        property: "min-height",
      });
    }

    matchHeightFire();

    $(window).bind("resize orientationchange", function () {
      matchHeightFire();
    });

    setTimeout(function () {
      matchHeightFire();
    }, 1000);

    function ajax_request($el, append = false) {
        let form = $el;

        if (form.data('requestRunning')) {
            return;
        }
        form.data('requestRunning', true);

        let data = {
            'action': 'posts_grid_loadmore',
        };

        $.each(form.serializeArray(), function(_, v) {
            data[v.name] = v.value;
        });

        $.ajax({
            url: theme.ajaxUrl,
            data: data,
            type: 'POST',
            beforeSend: function () {
            },
            success: function (data) {
                if (data) {
                    const $parent = form.closest('.block--posts-grid'),
                    $container = $parent.find('.container'),
                    $content = $parent.find('.content'),
                    $postsGrid = $parent.find('.content .posts_grid'),
                    $loadmore = $parent.find('.loadmore');

                    if(!append) {
                        $content.html(data);
                        scrollTo($container, 20);
                    } else {
                        const temp = $('<div></div>').html(data)
                        $postsGrid.html($postsGrid.html() + temp.find('.posts_grid').html());
                        $loadmore.replaceWith(temp.find('.loadmoreWrapper').html());
                    }

                    if($loadmore.length && parseInt($loadmore.attr('data-current')) >= parseInt($loadmore.attr('data-total')))
                        $loadmore.hide();
                }
            },
            complete: function() {
                form.data('requestRunning', false);
            },
        });
    }

    var initializeBlock = function ($block) {
        $block.find('form').submit(function (e) {
            e.preventDefault();
            $(this).find('[name="query_paged"]').val(1);
            ajax_request($(this));
        });
    }

    $(document).ready(function () {
        $('.block--posts-grid').each(function () {
            initializeBlock($(this));
        })

        $(document).on('click', '.block--posts-grid .pagination a.page-numbers', function(e) {
            e.preventDefault();
            const $parent = $(this).closest('.block--posts-grid'),
            page=/\/page\/(\d+)\//.exec($(this).attr('href')),
            paged=/\?paged=(\d+)/.exec($(this).attr('href'))
            $parent.find('form [name="paged"]').val(page ? page[1] : (paged ? paged[1] : 1));
            ajax_request($parent.find('form'));
        });

        $(document).on('click', '.block--posts-grid .loadmore', function(e) {
            e.preventDefault();
            const $parent = $(this).closest('.block--posts-grid');
            $parent.find('form [name="paged"]').val(parseInt($(this).attr('data-current')) + 1);
            ajax_request($parent.find('form'), true);
        });

        $(document).on('change', '.block--posts-grid input', function(e) {
            e.preventDefault();
            const $parent = $(this).closest('.block--posts-grid');
            $parent.find('form [name="paged"]').val(1);
            ajax_request($parent.find('form'));
        });

        $(document).on('click', '.block--posts-grid .filters-search a', function(e) {
            e.preventDefault();
            const $parent = $(this).closest('.block--posts-grid');
            ajax_request($parent.find('form'), true);
        });
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=posts-grid', initializeBlock);
    }

})(jQuery);